// extracted by mini-css-extract-plugin
module.exports = {"input":"InputSync_input__3_3YR","inputElement":"InputSync_inputElement__rD8Ol","errored":"InputSync_errored__34PO-","counter":"InputSync_counter__19AU9"};